'use client';

import {cn} from '@delorand/utils/cn';
import Footer from 'c/components/layout/footer';
import Header from 'c/components/layout/header/header';
import TopHeader from 'c/components/layout/header/top-header';

export default function DefaultLayout({children}: {children: React.ReactNode}) {
  return (
    <main
      className={cn(
        'flex min-h-screen w-full flex-col',
        'justify-between text-white md:pt-28 lg:pt-20'
      )}
    >
      <div className="center-x fixed top-0 z-20 w-full justify-center">
        <TopHeader />
        <Header />
      </div>

      <div className="w-full max-w-(--breakpoint-2xl) items-center pt-[50px] md:mx-auto md:pt-28 lg:pt-24">
        {children}
      </div>
      <Footer />
    </main>
  );
}
